import {
  EffectivePermissionsMap,
  FeaturePermission,
} from '@interfaces/featurePermission';
import { fetcher } from '@utils/fetcher';

const API_URL = '/api/featurePermission';

export const findFeaturePermissions = async (): Promise<FeaturePermission[]> =>
  fetcher(API_URL, { method: 'POST' });

/** O mapa efetivo por produto (§6.2). Substitui o cálculo que era feito no browser. */
export const findEffectivePermissions =
  async (): Promise<EffectivePermissionsMap> => fetcher(`${API_URL}/effective`);
